// import React, { useState, useEffect } from "react";
// import { IoClose } from "react-icons/io5";
// import { AiOutlineEye, AiOutlineFile } from "react-icons/ai";
// import { FiDownload } from "react-icons/fi";
// import { BsFiletypePdf, BsFiletypeJpg, BsFiletypePng } from "react-icons/bs";

// const ViewBarrelInward = ({ receiptId, onClose, showSnackbar, API_URL }) => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [receiptData, setReceiptData] = useState(null);

//   useEffect(() => {
//     if (receiptId) fetchReceiptDetails(receiptId);
//   }, [receiptId]);

//   const fetchReceiptDetails = async (id) => {
//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");
//       const response = await fetch(`${API_URL}/api/barrel/receipts/${id}`, {
//         headers: { Authorization: authKey },
//       });

//       if (!response.ok) {
//         throw new Error("Failed to fetch receipt details");
//       }

//       const data = await response.json();
//       setReceiptData(data);
//     } catch (error) {
//       console.error("Error fetching receipt:", error);
//       showSnackbar("Error fetching receipt details");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = date.toLocaleString("en-US", { month: "short" });
//     const year = date.getFullYear();
//     const hours = String(date.getHours()).padStart(2, "0");
//     const minutes = String(date.getMinutes()).padStart(2, "0");
//     return `${day} ${month} ${year}, ${hours}:${minutes}`;
//   };

//   const formatDateOnly = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   };

//   const formatFileSize = (bytes) => {
//     if (!bytes || bytes === 0) return "0 KB";
//     const kb = bytes / 1024;
//     if (kb < 1024) {
//       return `${kb.toFixed(2)} KB`;
//     }
//     const mb = kb / 1024;
//     return `${mb.toFixed(2)} MB`;
//   };

//   const handleViewDocument = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const viewUrl = `${API_URL}/api/barrel/receipts/${receiptId}/invoice/view`;

//       const response = await fetch(viewUrl, {
//         headers: {
//           Authorization: authKey,
//         },
//       });

//       if (!response.ok) {
//         throw new Error("Failed to fetch document");
//       }

//       const blob = await response.blob();
//       const contentType = response.headers.get("content-type") || "application/octet-stream";
//       const fileURL = window.URL.createObjectURL(blob);

//       const newWindow = window.open("", "_blank");

//       if (contentType.startsWith("image/")) {
//         newWindow.document.write(`
//         <!DOCTYPE html>
//         <html>
//           <head>
//             <title>Image Preview</title>
//             <style>
//               body { 
//                 margin: 0; 
//                 padding: 20px; 
//                 display: flex; 
//                 justify-content: center; 
//                 align-items: center; 
//                 min-height: 100vh;
//                 background-color: #f0f0f0;
//               }
//               img { 
//                 max-width: 100%; 
//                 max-height: 100vh; 
//                 object-fit: contain;
//                 box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//               }
//             </style>
//           </head>
//           <body>
//             <img src="${fileURL}" alt="Document Preview" />
//           </body>
//         </html>
//       `);
//       } else if (contentType === "application/pdf") {
//         newWindow.document.write(`
//         <!DOCTYPE html>
//         <html>
//           <head>
//             <title>PDF Preview</title>
//             <style>
//               body { margin: 0; padding: 0; }
//               iframe { width: 100%; height: 100vh; border: none; }
//             </style>
//           </head>
//           <body>
//             <iframe src="${fileURL}" type="application/pdf"></iframe>
//           </body>
//         </html>
//       `);
//       } else {
//         newWindow.document.write(`
//         <!DOCTYPE html>
//         <html>
//           <head>
//             <title>File Preview</title>
//             <style>
//               body { 
//                 font-family: Arial, sans-serif; 
//                 padding: 20px; 
//                 text-align: center;
//                 background-color: #f0f0f0;
//               }
//               .container {
//                 max-width: 400px;
//                 margin: 50px auto;
//                 padding: 30px;
//                 background: white;
//                 border-radius: 8px;
//                 box-shadow: 0 2px 10px rgba(0,0,0,0.1);
//               }
//               .download-btn {
//                 background-color: #007bff;
//                 color: white;
//                 padding: 10px 20px;
//                 border: none;
//                 border-radius: 4px;
//                 cursor: pointer;
//                 text-decoration: none;
//                 display: inline-block;
//                 margin-top: 20px;
//               }
//             </style>
//           </head>
//           <body>
//             <div class="container">
//               <h3>File Preview</h3>
//               <p>This file type cannot be previewed directly.</p>
//               <a href="${fileURL}" download class="download-btn">Download File</a>
//             </div>
//           </body>
//         </html>
//       `);
//       }

//       newWindow.document.close();

//       setTimeout(() => {
//         window.URL.revokeObjectURL(fileURL);
//       }, 10000);
//     } catch (error) {
//       console.error("Error viewing document:", error);
//       showSnackbar("Failed to view document");
//     }
//   };

//   const handleDownloadDocument = async (fileName) => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const response = await fetch(
//         `${API_URL}/api/barrel/receipts/${receiptId}/invoice/download`,
//         {
//           headers: { Authorization: authKey },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Failed to download document");
//       }

//       const blob = await response.blob();
//       const link = document.createElement("a");
//       link.href = window.URL.createObjectURL(blob);
//       link.download = fileName;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(link.href);
//       showSnackbar("Document downloaded successfully");
//     } catch (error) {
//       console.error("Error downloading document:", error);
//       showSnackbar("Error downloading document");
//     }
//   };

//   const getFileIcon = (fileType) => {
//     const type = fileType?.toLowerCase();
//     switch (type) {
//       case "pdf":
//         return <BsFiletypePdf size={40} color="#dc3545" />;
//       case "jpg":
//       case "jpeg":
//         return <BsFiletypeJpg size={40} color="#007bff" />;
//       case "png":
//         return <BsFiletypePng size={40} color="#28a745" />;
//       default:
//         return <AiOutlineFile size={40} color="#6c757d" />;
//     }
//   };

//   const getStatusBadge = (status) => {
//     return (
//       <span
//         style={{
//           backgroundColor: "#28a74520",
//           color: "#28a745",
//           padding: "6px 16px",
//           borderRadius: "12px",
//           fontSize: "14px",
//           fontWeight: "600",
//           display: "inline-block",
//           border: "1px solid #28a74540",
//         }}
//       >
//         {status || "Received"}
//       </span>
//     );
//   };

//   const renderDocumentCard = (title, fileName, fileType, fileSize, uploadDate) => {
//     if (!fileName) return null;

//     return (
//       <div style={{ marginBottom: "30px" }}>
//         <h5
//           style={{ margin: "0 0 15px 0", fontSize: "18px", fontWeight: "600" }}
//         >
//           {title}
//         </h5>
//         <div
//           style={{
//             backgroundColor: "#fff",
//             border: "1px solid #e0e0e0",
//             borderRadius: "12px",
//             padding: "20px",
//             boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//           }}
//         >
//           <div
//             style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}
//           >
//             <div
//               style={{
//                 backgroundColor: "#f8f9fa",
//                 padding: "15px",
//                 borderRadius: "8px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               {getFileIcon(fileType)}
//             </div>

//             <div style={{ flex: 1 }}>
//               <div style={{ marginBottom: "12px" }}>
//                 <div
//                   style={{
//                     fontSize: "16px",
//                     fontWeight: "600",
//                     color: "#333",
//                     marginBottom: "5px",
//                   }}
//                 >
//                   {fileName}
//                 </div>
//                 <div style={{ fontSize: "13px", color: "#666" }}>
//                   Uploaded on {formatDate(uploadDate)}
//                 </div>
//               </div>

//               <div
//                 style={{ display: "flex", gap: "20px", marginBottom: "15px" }}
//               >
//                 <div>
//                   <span
//                     style={{
//                       backgroundColor: "#e3f2fd",
//                       color: "#1976d2",
//                       padding: "4px 10px",
//                       borderRadius: "6px",
//                       fontSize: "12px",
//                       fontWeight: "600",
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     {fileType}
//                   </span>
//                 </div>
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "5px" }}
//                 >
//                   <span
//                     style={{
//                       fontSize: "13px",
//                       color: "#666",
//                       fontWeight: "500",
//                     }}
//                   >
//                     Size:
//                   </span>
//                   <span
//                     style={{
//                       fontSize: "13px",
//                       color: "#333",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {formatFileSize(fileSize)}
//                   </span>
//                 </div>
//               </div>

//               <div style={{ display: "flex", gap: "10px" }}>
//                 <button
//                   type="button"
//                   onClick={handleViewDocument}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     padding: "8px 16px",
//                     backgroundColor: "#007bff",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: "6px",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     cursor: "pointer",
//                     transition: "background-color 0.2s",
//                   }}
//                   onMouseOver={(e) =>
//                     (e.currentTarget.style.backgroundColor = "#0056b3")
//                   }
//                   onMouseOut={(e) =>
//                     (e.currentTarget.style.backgroundColor = "#007bff")
//                   }
//                 >
//                   <AiOutlineEye size={18} />
//                   View
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleDownloadDocument(fileName)}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     padding: "8px 16px",
//                     backgroundColor: "#28a745",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: "6px",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     cursor: "pointer",
//                     transition: "background-color 0.2s",
//                   }}
//                   onMouseOver={(e) =>
//                     (e.currentTarget.style.backgroundColor = "#218838")
//                   }
//                   onMouseOut={(e) =>
//                     (e.currentTarget.style.backgroundColor = "#28a745")
//                   }
//                 >
//                   <FiDownload size={18} />
//                   Download
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   if (isLoading) {
//     return (
//       <div className="purchase_indent_popup-overlay">
//         <div
//           className="purchase_indent_popup-modal"
//           style={{ maxWidth: "1000px" }}
//         >
//           <div style={{ padding: "40px", textAlign: "center" }}>
//             <div className="loader"></div>
//             <div>Loading...</div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!receiptData) return null;

//   const { receipt, items } = receiptData;

//   return (
//     <div className="purchase_indent_popup-overlay">
//       <div
//         className="purchase_indent_popup-modal"
//         style={{ maxWidth: "1000px", maxHeight: "90vh", overflow: "auto" }}
//       >
//         <div className="purchase_indent_popup-header">
//           <div>
//             <h4>Barrel Inward Details</h4>
//             <p style={{ margin: "5px 0 0 0", fontSize: "14px", color: "#666" }}>
//               {receipt?.receipt_number || "N/A"}
//             </p>
//           </div>
//           <span className="purchase_indent_close-btn" onClick={onClose}>
//             <IoClose />
//           </span>
//         </div>

//         <div className="purchase_indent_popup-body" style={{ padding: "30px" }}>
//           {/* Status and Basic Info Section */}
//           <div style={{ marginBottom: "30px" }}>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 marginBottom: "20px",
//               }}
//             >
//               <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
//                 Basic Information
//               </h5>
//               {getStatusBadge(receipt?.status)}
//             </div>

//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//                 gap: "20px",
//                 backgroundColor: "#f8f9fa",
//                 padding: "20px",
//                 borderRadius: "8px",
//               }}
//             >
//               <div>
//                 <div
//                   style={{
//                     fontSize: "12px",
//                     color: "#666",
//                     marginBottom: "5px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Receipt Date
//                 </div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>
//                   {formatDateOnly(receipt?.receipt_date)}
//                 </div>
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontSize: "12px",
//                     color: "#666",
//                     marginBottom: "5px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Vehicle Number
//                 </div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>
//                   {receipt?.vehicle_number || "N/A"}
//                 </div>
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontSize: "12px",
//                     color: "#666",
//                     marginBottom: "5px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Invoice Number
//                 </div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>
//                   {receipt?.invoice_number || "N/A"}
//                 </div>
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontSize: "12px",
//                     color: "#666",
//                     marginBottom: "5px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Created Date
//                 </div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>
//                   {formatDate(receipt?.created_at)}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Supplier Information */}
//           <div style={{ marginBottom: "30px" }}>
//             <h5
//               style={{
//                 margin: "0 0 15px 0",
//                 fontSize: "18px",
//                 fontWeight: "600",
//               }}
//             >
//               Supplier Information
//             </h5>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//                 gap: "20px",
//                 backgroundColor: "#f8f9fa",
//                 padding: "20px",
//                 borderRadius: "8px",
//               }}
//             >
//               <div>
//                 <div
//                   style={{
//                     fontSize: "12px",
//                     color: "#666",
//                     marginBottom: "5px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Supplier Name
//                 </div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>
//                   {receipt?.supplier_name || "N/A"}
//                 </div>
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontSize: "12px",
//                     color: "#666",
//                     marginBottom: "5px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Contact Person
//                 </div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>
//                   {receipt?.contact_person || "N/A"}
//                 </div>
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontSize: "12px",
//                     color: "#666",
//                     marginBottom: "5px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Contact Number
//                 </div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>
//                   {receipt?.contact_number || "N/A"}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Products Section */}
//           <div style={{ marginBottom: "30px" }}>
//             <h5
//               style={{
//                 margin: "0 0 15px 0",
//                 fontSize: "18px",
//                 fontWeight: "600",
//               }}
//             >
//               Products
//             </h5>
//             <div
//               style={{
//                 border: "1px solid #ddd",
//                 borderRadius: "8px",
//                 overflow: "hidden",
//               }}
//             >
//               <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                   <tr style={{ backgroundColor: "#f8f9fa" }}>
//                     <th
//                       style={{
//                         padding: "12px",
//                         textAlign: "left",
//                         fontSize: "13px",
//                         fontWeight: "600",
//                         color: "#666",
//                         borderBottom: "2px solid #ddd",
//                       }}
//                     >
//                       SR
//                     </th>
//                     <th
//                       style={{
//                         padding: "12px",
//                         textAlign: "left",
//                         fontSize: "13px",
//                         fontWeight: "600",
//                         color: "#666",
//                         borderBottom: "2px solid #ddd",
//                       }}
//                     >
//                       Product Code
//                     </th>
//                     <th
//                       style={{
//                         padding: "12px",
//                         textAlign: "left",
//                         fontSize: "13px",
//                         fontWeight: "600",
//                         color: "#666",
//                         borderBottom: "2px solid #ddd",
//                       }}
//                     >
//                       Product Name
//                     </th>
//                     <th
//                       style={{
//                         padding: "12px",
//                         textAlign: "right",
//                         fontSize: "13px",
//                         fontWeight: "600",
//                         color: "#666",
//                         borderBottom: "2px solid #ddd",
//                       }}
//                     >
//                       Quantity (KL)
//                     </th>
//                     <th
//                       style={{
//                         padding: "12px",
//                         textAlign: "right",
//                         fontSize: "13px",
//                         fontWeight: "600",
//                         color: "#666",
//                         borderBottom: "2px solid #ddd",
//                       }}
//                     >
//                       No. of Barrels
//                     </th>
//                     <th
//                       style={{
//                         padding: "12px",
//                         textAlign: "left",
//                         fontSize: "13px",
//                         fontWeight: "600",
//                         color: "#666",
//                         borderBottom: "2px solid #ddd",
//                       }}
//                     >
//                       UOM
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {items && items.length > 0 ? (
//                     items.map((item, index) => (
//                       <tr
//                         key={item.id}
//                         style={{
//                           borderBottom:
//                             index < items.length - 1
//                               ? "1px solid #f0f0f0"
//                               : "none",
//                         }}
//                       >
//                         <td style={{ padding: "12px", fontSize: "14px" }}>
//                           {index + 1}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontSize: "14px",
//                             fontWeight: "500",
//                           }}
//                         >
//                           {item.product_code}
//                         </td>
//                         <td style={{ padding: "12px", fontSize: "14px" }}>
//                           {item.product_name}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontSize: "14px",
//                             textAlign: "right",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {parseFloat(item.quantity).toFixed(2)}
//                         </td>
//                         <td
//                           style={{
//                             padding: "12px",
//                             fontSize: "14px",
//                             textAlign: "right",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {parseFloat(item.quantity_in_barrels).toFixed(2)}
//                         </td>
//                         <td style={{ padding: "12px", fontSize: "14px" }}>
//                           {item.uom}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan="6"
//                         style={{
//                           padding: "20px",
//                           textAlign: "center",
//                           color: "#999",
//                         }}
//                       >
//                         No products found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Invoice Document */}
//           {receipt?.invoice_file_name &&
//             renderDocumentCard(
//               "Invoice Document",
//               receipt.invoice_file_name,
//               receipt.invoice_file_type || "pdf",
//               receipt.invoice_file_size,
//               receipt.created_at
//             )}
//         </div>

//         <div className="purchase_indent_popup-footer">
//           <button
//             className="purchase_indent_btn purchase_indent_btn-cancel"
//             onClick={onClose}
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ViewBarrelInward;


import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import { AiOutlineEye, AiOutlineFile } from "react-icons/ai";
import { FiDownload } from "react-icons/fi";
import { BsFiletypePdf, BsFiletypeJpg, BsFiletypePng } from "react-icons/bs";

const ViewBarrelInward = ({ receiptId, onClose, showSnackbar, API_URL }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [receiptData, setReceiptData] = useState(null);

  useEffect(() => {
    if (receiptId) fetchReceiptDetails(receiptId);
  }, [receiptId]);

  const fetchReceiptDetails = async (id) => {
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const response = await fetch(`${API_URL}/api/barrel/receipts/${id}`, {
        headers: { Authorization: authKey },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch receipt details");
      }

      const data = await response.json();
      setReceiptData(data);
    } catch (error) {
      console.error("Error fetching receipt:", error);
      showSnackbar("Error fetching receipt details");
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  const formatDateOnly = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return "0 KB";
    const kb = bytes / 1024;
    if (kb < 1024) {
      return `${kb.toFixed(2)} KB`;
    }
    const mb = kb / 1024;
    return `${mb.toFixed(2)} MB`;
  };

  const handleViewDocument = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const viewUrl = `${API_URL}/api/barrel/receipts/${receiptId}/invoice/view`;

      const response = await fetch(viewUrl, {
        headers: {
          Authorization: authKey,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch document");
      }

      const blob = await response.blob();
      const contentType = response.headers.get("content-type") || "application/octet-stream";
      const fileURL = window.URL.createObjectURL(blob);

      const newWindow = window.open("", "_blank");

      if (contentType.startsWith("image/")) {
        newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Image Preview</title>
            <style>
              body { 
                margin: 0; 
                padding: 20px; 
                display: flex; 
                justify-content: center; 
                align-items: center; 
                min-height: 100vh;
                background-color: #f0f0f0;
              }
              img { 
                max-width: 100%; 
                max-height: 100vh; 
                object-fit: contain;
                box-shadow: 0 4px 8px rgba(0,0,0,0.1);
              }
            </style>
          </head>
          <body>
            <img src="${fileURL}" alt="Document Preview" />
          </body>
        </html>
      `);
      } else if (contentType === "application/pdf") {
        newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              body { margin: 0; padding: 0; }
              iframe { width: 100%; height: 100vh; border: none; }
            </style>
          </head>
          <body>
            <iframe src="${fileURL}" type="application/pdf"></iframe>
          </body>
        </html>
      `);
      } else {
        newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>File Preview</title>
            <style>
              body { 
                font-family: Arial, sans-serif; 
                padding: 20px; 
                text-align: center;
                background-color: #f0f0f0;
              }
              .container {
                max-width: 400px;
                margin: 50px auto;
                padding: 30px;
                background: white;
                border-radius: 8px;
                box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              }
              .download-btn {
                background-color: #007bff;
                color: white;
                padding: 10px 20px;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                text-decoration: none;
                display: inline-block;
                margin-top: 20px;
              }
            </style>
          </head>
          <body>
            <div class="container">
              <h3>File Preview</h3>
              <p>This file type cannot be previewed directly.</p>
              <a href="${fileURL}" download class="download-btn">Download File</a>
            </div>
          </body>
        </html>
      `);
      }

      newWindow.document.close();

      setTimeout(() => {
        window.URL.revokeObjectURL(fileURL);
      }, 10000);
    } catch (error) {
      console.error("Error viewing document:", error);
      showSnackbar("Failed to view document");
    }
  };

  const handleDownloadDocument = async (fileName) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await fetch(
        `${API_URL}/api/barrel/receipts/${receiptId}/invoice/download`,
        {
          headers: { Authorization: authKey },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download document");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
      showSnackbar("Document downloaded successfully");
    } catch (error) {
      console.error("Error downloading document:", error);
      showSnackbar("Error downloading document");
    }
  };

  const getFileIcon = (fileType) => {
    const type = fileType?.toLowerCase();
    switch (type) {
      case "pdf":
        return <BsFiletypePdf size={40} color="#dc3545" />;
      case "jpg":
      case "jpeg":
        return <BsFiletypeJpg size={40} color="#007bff" />;
      case "png":
        return <BsFiletypePng size={40} color="#28a745" />;
      default:
        return <AiOutlineFile size={40} color="#6c757d" />;
    }
  };

  const getStatusBadge = (status) => {
    return (
      <span
        style={{
          backgroundColor: "#28a74520",
          color: "#28a745",
          padding: "6px 16px",
          borderRadius: "12px",
          fontSize: "14px",
          fontWeight: "600",
          display: "inline-block",
          border: "1px solid #28a74540",
        }}
      >
        {status || "Received"}
      </span>
    );
  };

  const renderDocumentCard = (title, fileName, fileType, fileSize, uploadDate) => {
    if (!fileName) return null;

    return (
      <div style={{ marginBottom: "30px" }}>
        <h5
          style={{ margin: "0 0 15px 0", fontSize: "18px", fontWeight: "600" }}
        >
          {title}
        </h5>
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <div
            style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}
          >
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "15px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {getFileIcon(fileType)}
            </div>

            <div style={{ flex: 1 }}>
              <div style={{ marginBottom: "12px" }}>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "5px",
                  }}
                >
                  {fileName}
                </div>
                <div style={{ fontSize: "13px", color: "#666" }}>
                  Uploaded on {formatDate(uploadDate)}
                </div>
              </div>

              <div
                style={{ display: "flex", gap: "20px", marginBottom: "15px" }}
              >
                <div>
                  <span
                    style={{
                      backgroundColor: "#e3f2fd",
                      color: "#1976d2",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "12px",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    {fileType}
                  </span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#666",
                      fontWeight: "500",
                    }}
                  >
                    Size:
                  </span>
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#333",
                      fontWeight: "600",
                    }}
                  >
                    {formatFileSize(fileSize)}
                  </span>
                </div>
              </div>

              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  type="button"
                  onClick={handleViewDocument}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 16px",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0056b3")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#007bff")
                  }
                >
                  <AiOutlineEye size={18} />
                  View
                </button>

                <button
                  type="button"
                  onClick={() => handleDownloadDocument(fileName)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 16px",
                    backgroundColor: "#28a745",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#218838")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#28a745")
                  }
                >
                  <FiDownload size={18} />
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (isLoading) {
    return (
      <div className="purchase_indent_popup-overlay">
        <div
          className="purchase_indent_popup-modal"
          style={{ maxWidth: "1000px" }}
        >
          <div style={{ padding: "40px", textAlign: "center" }}>
            <div className="loader"></div>
            <div>Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!receiptData) return null;

  const { receipt, items } = receiptData;

  return (
    <div className="purchase_indent_popup-overlay">
      <div
        className="purchase_indent_popup-modal"
        style={{ maxWidth: "1000px", maxHeight: "90vh", overflow: "auto" }}
      >
        <div className="purchase_indent_popup-header">
          <div>
            <h4>Barrel Inward Details</h4>
            <p style={{ margin: "5px 0 0 0", fontSize: "14px", color: "#666" }}>
              {receipt?.receipt_number || "N/A"}
            </p>
          </div>
          <span className="purchase_indent_close-btn" onClick={onClose}>
            <IoClose />
          </span>
        </div>

        <div className="purchase_indent_popup-body" style={{ padding: "30px" }}>
          {/* Status and Basic Info Section */}
          <div style={{ marginBottom: "30px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
                Basic Information
              </h5>
              {getStatusBadge(receipt?.receipt_status)}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "20px",
                backgroundColor: "#f8f9fa",
                padding: "20px",
                borderRadius: "8px",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Receipt Number
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {receipt?.receipt_number || "N/A"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Receipt Date
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {formatDateOnly(receipt?.receipt_date)}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Vehicle Number
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {receipt?.vehicle_number || "N/A"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Driver Name
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {receipt?.driver_name || "N/A"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Invoice Number
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {receipt?.invoice_number || "N/A"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Created Date
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {formatDate(receipt?.created_at)}
                </div>
              </div>
            </div>
          </div>

          {/* Supplier Information */}
          <div style={{ marginBottom: "30px" }}>
            <h5
              style={{
                margin: "0 0 15px 0",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Supplier Information
            </h5>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "20px",
                backgroundColor: "#f8f9fa",
                padding: "20px",
                borderRadius: "8px",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Supplier Name
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {receipt?.supplier_name || "N/A"}
                </div>
              </div>
            </div>
          </div>

          {/* Remarks Section (if available) */}
          {receipt?.remarks && (
            <div style={{ marginBottom: "30px" }}>
              <h5
                style={{
                  margin: "0 0 15px 0",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Remarks
              </h5>
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  padding: "20px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  color: "#333",
                }}
              >
                {receipt.remarks}
              </div>
            </div>
          )}

          {/* Products Section */}
          <div style={{ marginBottom: "30px" }}>
            <h5
              style={{
                margin: "0 0 15px 0",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Products
            </h5>
            <div
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      SR
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      Product Code
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      Product Name
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "right",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      Quantity (KL)
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "right",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      No. of Barrels
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      UOM
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items && items.length > 0 ? (
                    items.map((item, index) => (
                      <tr
                        key={item.id}
                        style={{
                          borderBottom:
                            index < items.length - 1
                              ? "1px solid #f0f0f0"
                              : "none",
                        }}
                      >
                        <td style={{ padding: "12px", fontSize: "14px" }}>
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {item.product_code}
                        </td>
                        <td style={{ padding: "12px", fontSize: "14px" }}>
                          {item.product_name}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            textAlign: "right",
                            fontWeight: "600",
                          }}
                        >
                          {parseFloat(item.quantity).toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            textAlign: "right",
                            fontWeight: "600",
                          }}
                        >
                          {item.barrel_count}
                        </td>
                        <td style={{ padding: "12px", fontSize: "14px" }}>
                          {item.uom}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#999",
                        }}
                      >
                        No products found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Invoice Document */}
          {receipt?.invoice_file_name &&
            renderDocumentCard(
              "Invoice Document",
              receipt.invoice_file_name,
              receipt.invoice_file_type || "pdf",
              receipt.invoice_file_size,
              receipt.created_at
            )}
        </div>

        <div className="purchase_indent_popup-footer">
          <button
            className="purchase_indent_btn purchase_indent_btn-cancel"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewBarrelInward;